import { render, staticRenderFns } from "./AddNursery.vue?vue&type=template&id=3cb98524&scoped=true"
import script from "./AddNursery.vue?vue&type=script&lang=js"
export * from "./AddNursery.vue?vue&type=script&lang=js"
import style0 from "./AddNursery.vue?vue&type=style&index=0&id=3cb98524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb98524",
  null
  
)

export default component.exports